import { AmountText } from '@/components/AmountText';
import { Checkbox } from '@moneyskyline/ui';
import type { AskReviewRow } from '@/api/hooks/askSchemas';

export function AskMatchRow({ row, kept, onToggle }: { row: AskReviewRow; kept: boolean; onToggle: (id: string) => void }) {
  const writable = row.bank_state !== 'non_writable';
  const accountLabel = row.account.last4 ? `${row.account.display_name} · ${row.account.last4}` : row.account.display_name;
  return (
    <div className="flex items-center gap-2.5 border-b border-border/60 px-3 py-2 text-sm last:border-b-0" data-testid="ask-match-row" data-line-item-id={row.line_item_id}>
      <Checkbox checked={kept} disabled={!writable} onCheckedChange={() => onToggle(row.line_item_id)} aria-label={`${writable ? 'Keep' : 'Cannot keep'} ${row.merchant}`} />
      <span className="flex-1">
        <span className={writable ? '' : 'text-muted-foreground line-through'}>{row.merchant}</span>
        <span className="ml-1 text-muted-foreground">{row.posted_day} · {accountLabel}{row.pending ? ' · pending' : ''}</span>
      </span>
      <AmountText value={row.amount} currency={row.currency} className={!writable ? 'text-muted-foreground' : ''} />
      {!writable && <span className="text-xs text-muted-foreground">Unavailable</span>}
    </div>
  );
}

export default AskMatchRow;
